export const Icon = () => {
    return (
        <span className="text-lg font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-teal-400">
            Morphic
        </span>
    )
}
